// removed by extract-text-webpack-plugin
module.exports = {"sidebar":"BsOtqbEt6ZNY4XmDKXw3z","fixed":"LwhfMsliTevaOWngmLefA","logo":"_20bImnCO6Lcf7DjILLkqmZ","optionsList":"_2bXJQfQ38uRnYgeIXPIJG8","pageKey":"_2TcazhGvR0J6U2TS-Zm5fr","active":"xY6HOYA3snawM0JvUnYi5","handle":"_1y1697h10eQx3hYuwKtgzL","subkey":"_3yHplIP8QWiWFRNh6a_dSd","options":"_184BBfQ1TCKZZIXOVvHTkQ","mainOptionContainer":"_1v12FinLH48DQ06QyMoEIa","activeMobile":"_3Yzf6400d4HXCiDAuqaZac","subOptions":"_1J_2ykRFl9T7M2FSfY91Ag","menuMainLink":"xco1g_xOyHZhMY4q51HcD","sidebarContents":"_1kWlyyKcExgzbF9OHzL6-p"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Sidebar/style.css
// module id = 670
// module chunks = 0